import api from "../lib/axios";

export const getAgendaData = async (eventId, token) => {
  const res = await api.get(`/agenda/events/${eventId}`, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    validateStatus: () => true,
  });
  return res;
};

export const updateAgenda = async (eventId, formData, token) => {
  const res = await api.put(`/agenda/events/${eventId}`, formData, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },

    validateStatus: () => true,
  });

  return res;
};

export const getAgendaSessionCategories = async (eventId, token) => {
  const res = await api.get(`/agenda/session-categories`, {
    params: { event_id: eventId },
    headers: {
      "Content-Type": "application/json",
    },
    validateStatus: () => true,
  });
  return res;
};

export const getAgendaAccessOptions = async (eventId, token) => {
  const res = await api.get(`/zone/getTicketsForZone`, {
    params: { event_id: eventId },
    headers: {
      "Content-Type": "application/json",
    },
    validateStatus: () => true,
  });
  return res;
};

export const getAgendaEventSchedule = async (eventId, search) => {
  const res = await api.get(`/agenda/events/${eventId}`, {
    params: search ? { search } : {},
    headers: {
      "Content-Type": "application/json",
      "ngrok-skip-browser-warning": "true",
    },
  });
  return res;
};
